import React from 'react';
import { type FC, useEffect } from 'react';

import { Frame, type ReplacementLayer, ReplacementLayerType } from './frame';
import { useCreativeGeneratorStore } from './store';

export const Stage: FC = () => {
    const currentVariant = useCreativeGeneratorStore((s) => {
        const currentVariantIndex = s.currentVariantIndex;
        return currentVariantIndex >= 0 ? s.creative?.creativeVariants[currentVariantIndex].variant : null;
    });
    const fields = useCreativeGeneratorStore((s) => s.creative?.templateVersion.fields);
    const selectedContentVariant = useCreativeGeneratorStore((s) => {
        const selectedContentVariantIndex = s.selectedContentVariantIndex;
        return selectedContentVariantIndex >= 0 ? s.creative?.contentVariants[selectedContentVariantIndex] : null;
    });
    const [replacementLayers, setReplacementLayers] = React.useState<ReplacementLayer[]>([]);

    useEffect(() => {
        const updatedReplacementLayers: ReplacementLayer[] = [];
        for (const fieldValue of selectedContentVariant?.fieldValues || []) {
            const field = fields?.find((f) => f.id === fieldValue.field);
            const linkedLayer = field?.linkedLayers?.find((l) => l.variant === currentVariant?.id);
            if (linkedLayer) {
                updatedReplacementLayers.push({
                    layerUuid: linkedLayer.layerUuid,
                    type: ReplacementLayerType.Text,
                    rect: {
                        x: linkedLayer.posX,
                        y: linkedLayer.posY,
                        width: linkedLayer.width,
                        height: linkedLayer.height,
                    },
                    props: {
                        text: fieldValue.value,
                        fontSize: linkedLayer.fontSize,
                        fontFamily: linkedLayer.fontFamily,
                        fontWeight: linkedLayer.fontWeight,
                        fontStyle: linkedLayer.fontStyle,
                        lineHeight: linkedLayer.lineHeight,
                        fill: linkedLayer.fill,
                        autoScaling: field?.properties.autoTextScaling || false,
                        charLimit: field?.properties.charLimit || 0,
                    },
                });
            }
        }
        setReplacementLayers(updatedReplacementLayers);
    }, [currentVariant, fields, selectedContentVariant?.fieldValues]);

    return (
        <div className="flex flex-row bg-gray-800 w-full h-full p-6 justify-around items-center gap-6 overflow-auto">
            {currentVariant && <Frame variant={currentVariant} replacementLayers={replacementLayers} />}
        </div>
    );
};
